import React from 'react'

import HELPTEXT from '../../../business-const/HelpText/HelpText'

import LABEL from '../../../business-const/Label/Label'

import MESSAGE from '../../../business-const/Message/Message'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import NUMMIN from '../../../business-rules/NumMinMax/NumMin'

import NUMMAX from '../../../business-rules/NumMinMax/NumMax'

import {
    TablePaginationPadrao,
    rowPertentePage,
    setPageInclusao,
    setPageExclusao,
} from '../../../business-components/Pagination/Pagination'

import { 
    MuiPickersUtilsProviderPadrao,
    KeyboardDatePickerPadrao,
} from '../../../business-components/MuiPickers/MuiPickers'

import {
    TextValidatorText,
    TextValidatorNumber,
    TextValidatorNumberRequired,
    TextValidatorValor,
    TextValidatorValorRequired,
    TextValidatorTextMultiline,
} from '../../../business-components/TextValidator/TextValidator'

import {
    TextFieldTextSelect,
    TextFieldTextSelectRequired,
    TextFieldNumberSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    CheckboxPadrao
} from '../../../business-components/Checkbox/Checkbox'

import tipoPatrimonioImobilizadoList from '../../../business-rules/List/tipoPatrimonioImobilizadoList'

import tipoFinalidadePatrimonioImobilizadoList from '../../../business-rules/List/tipoFinalidadePatrimonioImobilizadoList'

//import tipoImovelList from '../../../business-rules/List/tipoImovelList'

import tipoEmpresaList from '../../../business-rules/List/tipoEmpresaList'

import tipoRegimeTributarioEmpresaList from '../../../business-rules/List/tipoRegimeTributarioEmpresaList'

import tipoPlanejamentoSucessorioList from '../../../business-rules/List/tipoPlanejamentoSucessorioList'

import ufList from '../../../business-rules/List/ufList'

import {
    IconButtonClearEntradaDados,
    IconButtonHelp,
} from '../../../business-components/IconButton/IconButton'

import {
    tituloCliente,
    tituloConjuge,
} from '../cliente-form/ClienteService'

import {
    atualizaPerguntaValor,
} from '../form-form/FormServicePerguntas'

import {
    processaAlteracaoPatrimonioImobilizadoTipoPatrimonioImobilizado,
    processaAlteracaoPatrimonioImobilizadoAlugado,
    processaAlteracaoPatrimonioImobilizadoPercPatrimonioImobilizadoCliente,
} from './GarantiasServicePatrimonioImobilizado'



export const TablePaginationPadraoPatrimonioImobilizado = ({ values, setFieldValue }) => {

    return (
        <TablePaginationPadrao
            setFieldValue={setFieldValue}
            list={values.patrimonioImobilizadoPagination}
            nameRowsPerPage={'rowsPerPagePatrimonioImobilizado'}
            namePage={'pagePatrimonioImobilizado'}
            rowsPerPage={values.rowsPerPagePatrimonioImobilizado}
            page={values.pagePatrimonioImobilizado}
        />
    )
}

export const rowPertentePagePatrimonioImobilizado = (values, indAux) => {
    
    return rowPertentePage(indAux, values.pagePatrimonioImobilizado, values.rowsPerPagePatrimonioImobilizado)
}

export const setPageInclusaoPatrimonioImobilizado = (values, setFieldValue) => {

    return setPageInclusao(setFieldValue, 'pagePatrimonioImobilizado', values.patrimonioImobilizadoPagination, values.rowsPerPagePatrimonioImobilizado)
}



export const Familiar = ({ values, item, ind, handleChange, expandiu }) => {

    return (
        <TextFieldNumberSelect
            name={`patrimonioImobilizado[${ind}].familiar`}
            label={LABEL.familiarInventario}
            value={item.familiar || ''}
            onChange={handleChange}
            list={values.totalPatrimonioImobilizado}
            disabled={expandiu}
        />
    )
}

export const TipoPatrimonioImobilizado = ({ TextFieldNumberSelectTipoPatrimonioImobilizado, item, ind, handleChange, expandiu }) => {

    return (
        <TextFieldNumberSelectTipoPatrimonioImobilizado
            name={`patrimonioImobilizado[${ind}].tipoPatrimonioImobilizado`}
            placeholder={LABEL.tipoPatrimonioImobilizado}
            value={item.tipoPatrimonioImobilizado || ''}
            onChange={handleChange}
            list={tipoPatrimonioImobilizadoList}
            onBlur={processaAlteracaoPatrimonioImobilizadoTipoPatrimonioImobilizado(item)}
            disabled={expandiu}
        />
    )
}

export const HelpTipoPatrimonioImobilizado = ({ tipoPatrimonioImobilizadoSelecionado }) => {

    return (
        tipoPatrimonioImobilizadoSelecionado.help
            ?
                <IconButtonHelp
                    helpTitle={tipoPatrimonioImobilizadoSelecionado.descricao}
                    helpText={tipoPatrimonioImobilizadoSelecionado.help}
                />
            :
                ''
    )
}

export const IconButtonClearEntradaDadosPatrimonioImobilizado = ({ values, setFieldValue, item, ind, arrayHelpers, simplificado }) => {

    return (
        !item.idPergunta && !simplificado
            ?
                <IconButtonClearEntradaDados
                    onClick={() => {
                        arrayHelpers.remove(ind)
                        setPageExclusao(setFieldValue, 'pagePatrimonioImobilizado', values.patrimonioImobilizadoPagination,
                            values.rowsPerPagePatrimonioImobilizado, values.pagePatrimonioImobilizado)
                    }}
                />
            :
                ''
    )
}

export const TipoFinalidadePatrimonioImobilizado = ({ item, ind, handleChange }) => {

    return (
        <TextFieldTextSelect
            name={`patrimonioImobilizado[${ind}].tipoFinalidadePatrimonioImobilizado`}
            label={LABEL.tipoFinalidadePatrimonioImobilizado}
            value={item.tipoFinalidadePatrimonioImobilizado || ''}
            onChange={handleChange}
            list={tipoFinalidadePatrimonioImobilizadoList(false)}
        />
    )
}

export const Valor = ({ values, item, ind, handleChange, expandiu }) => {

    return (
        <TextValidatorValorRequired
            name={`patrimonioImobilizado[${ind}].valor`}
            label={LABEL.valorMercado}
            value={item.valor || ''}
            onChange={handleChange}
            onBlur={
                atualizaPerguntaValor(values, item.idPergunta,
                    item.valor)
            }
            disabled={expandiu}
        />
    )
}

export const Alugado = ({ item, ind, handleChange }) => {

    return (
        <CheckboxPadrao
            name={`patrimonioImobilizado[${ind}].alugado`}
            label={LABEL.alugado}
            checked={item.alugado}
            onChange={handleChange}
            onBlur={processaAlteracaoPatrimonioImobilizadoAlugado(item)}
        />
    )
}

export const ValorAluguel = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorValorRequired
            name={`patrimonioImobilizado[${ind}].valorAluguel`}
            label={LABEL.valorAluguel}
            value={item.valorAluguel || ''}
            onChange={handleChange}
        />
    )
}

export const PercPatrimonioImobilizadoCliente = ({ values, item, ind, handleChange, expandiu }) => {

    return (
        <TextValidatorNumberRequired
            name={`patrimonioImobilizado[${ind}].percPatrimonioImobilizadoCliente`}
            label={LABEL.perc + " " + tituloCliente(values)}
            value={item.percPatrimonioImobilizadoCliente === 0 ? 0 : item.percPatrimonioImobilizadoCliente || ''}
            onChange={handleChange}
            numMin={NUMMIN.perc}
            numMax={NUMMAX.perc}
            onBlur={
                processaAlteracaoPatrimonioImobilizadoPercPatrimonioImobilizadoCliente(values, 
                    item)
            }
            disabled={expandiu}
        />
    )
}

export const PercPatrimonioImobilizadoConjuge = ({ values, item, ind, handleChange }) => {

    return (
        <TextValidatorNumber
            name={`patrimonioImobilizado[${ind}].percPatrimonioImobilizadoConjuge`}
            label={LABEL.perc + " " + tituloConjuge(values)}
            value={item.percPatrimonioImobilizadoConjuge === 0 ? 0 : item.percPatrimonioImobilizadoConjuge || ''}
            onChange={handleChange}
            numMin={NUMMIN.perc}
            numMax={NUMMAX.perc}
            disabled={true}
        />
    )
}

export const NaoInventariar = ({ item, ind, handleChange }) => {

    return (
        <CheckboxPadrao
            name={`patrimonioImobilizado[${ind}].naoInventariar`}
            label={LABEL.naoInventariar}
            checked={item.naoInventariar}
            onChange={handleChange}
        />
    )
}

export const HelpNaoInventariar = () => {

    return (
        <IconButtonHelp
            helpTitle={LABEL.naoInventariar}
            helpText={HELPTEXT.naoInventariarPatrimonioImobilizado}
        />
    )
}

export const UfItcmd = ({ item, ind, handleChange, expandiu }) => {

    return (
        <TextFieldTextSelectRequired
            name={`patrimonioImobilizado[${ind}].ufItcmd`}
            label={LABEL.uf}
            value={item.ufItcmd || ''}
            onChange={handleChange}
            list={ufList(false)}
            mensagemAlerta={MESSAGE().campoImportanteITCMD}
            disabled={expandiu}
        />
    )
}

export const PercDespesasAdvocaticias = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorNumber
            name={`patrimonioImobilizado[${ind}].percDespesasAdvocaticias`}
            label={LABEL.percDespesasAdvocaticias}
            value={item.percDespesasAdvocaticias === 0 ? 0 : item.percDespesasAdvocaticias || ''}
            onChange={handleChange}
            numMin={NUMMIN.perc}
            numMax={NUMMAX.perc}
        />
    )
}

export const PercCustasJudiciais = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorNumber
            name={`patrimonioImobilizado[${ind}].percCustasJudiciais`}
            label={LABEL.percCustasJudiciais}
            value={item.percCustasJudiciais === 0 ? 0 : item.percCustasJudiciais || ''}
            onChange={handleChange}
            numMin={NUMMIN.perc}
            numMax={NUMMAX.perc}
        />
    )
}

export const PercInventarioItcmd = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorNumber
            name={`patrimonioImobilizado[${ind}].percInventarioItcmd`}
            label={LABEL.percItcmd}
            value={item.percInventarioItcmd === 0 ? 0 : item.percInventarioItcmd || ''}
            onChange={handleChange}
            numMin={NUMMIN.perc}
            numMax={NUMMAX.perc}
        />
    )
}

export const ConsiderarGarantiaMorteInvalidezCliente = ({ values, item, ind, handleChange }) => {

    return (
        <CheckboxPadrao
            name={`patrimonioImobilizado[${ind}].considerarGarantiaMorteInvalidezCliente`}
            label={LABEL.considerarGarantiaMorteInvalidez + ' ' + tituloCliente(values)}
            checked={item.considerarGarantiaMorteInvalidezCliente}
            onChange={handleChange}
        />
    )
}

export const ConsiderarGarantiaMorteInvalidezConjuge = ({ values, item, ind, handleChange }) => {

    return (
        <CheckboxPadrao
            name={`patrimonioImobilizado[${ind}].considerarGarantiaMorteInvalidezConjuge`}
            label={LABEL.considerarGarantiaMorteInvalidez + ' ' + tituloConjuge(values)}
            checked={item.considerarGarantiaMorteInvalidezConjuge}
            onChange={handleChange}
        />
    )
}

export const HelpConsiderarGarantiaMorteInvalidez = () => {

    return (
        <IconButtonHelp
            helpTitle={LABEL.considerarGarantiaMorteInvalidez}
            helpText={HELPTEXT.considerarGarantiaMorteInvalidez}
        />
    )
}

/*
export const TipoImovel = ({ item, ind, handleChange }) => {

    return (
        <TextFieldTextSelect
            name={`patrimonioImobilizado[${ind}].tipoImovel`}
            label={LABEL.tipoImovel}
            value={item.tipoImovel || ''}
            onChange={handleChange}
            list={tipoImovelList}
        />
    )
}
*/

export const ValorContabil = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorValor
            name={`patrimonioImobilizado[${ind}].valorContabil`}
            label={LABEL.valorContabil}
            value={item.valorContabil || ''}
            onChange={handleChange}
        />
    )
}

export const DataCompra = ({ item, ind, setFieldValue }) => {

    return (
        <MuiPickersUtilsProviderPadrao>
            <KeyboardDatePickerPadrao
                name={`patrimonioImobilizado[${ind}].dataCompra`}
                label={LABEL.dataCompra}
                value={item.dataCompra}
                onChange={(date) => {
                    setFieldValue(
                        `patrimonioImobilizado[${ind}].dataCompra`,
                        date,
                    )}
                }
            />
        </MuiPickersUtilsProviderPadrao>
    )
}

export const ValorCompra = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorValor
            name={`patrimonioImobilizado[${ind}].valorCompra`}
            label={LABEL.valorCompra}
            value={item.valorCompra || ''}
            onChange={handleChange}
        />
    )
}

export const TipoEmpresa = ({ item, ind, handleChange }) => {

    return (
        <TextFieldTextSelect
            name={`patrimonioImobilizado[${ind}].tipoEmpresa`}
            label={LABEL.tipoEmpresa}
            value={item.tipoEmpresa || ''}
            onChange={handleChange}
            list={tipoEmpresaList}
        />
    )
}

export const TipoRegimeTributarioEmpresa = ({ item, ind, handleChange }) => {

    return (
        <TextFieldTextSelect
            name={`patrimonioImobilizado[${ind}].tipoRegimeTributarioEmpresa`}
            label={LABEL.tipoRegimeTributarioEmpresa}
            value={item.tipoRegimeTributarioEmpresa || ''}
            onChange={handleChange}
            list={tipoRegimeTributarioEmpresaList}
        />
    )
}

export const TipoPlanejamentoSucessorio = ({ item, ind, handleChange }) => {

    return (
        <TextFieldTextSelect
            name={`patrimonioImobilizado[${ind}].tipoPlanejamentoSucessorio`}
            label={LABEL.tipoPlanejamentoSucessorio}
            value={item.tipoPlanejamentoSucessorio || ''}
            onChange={handleChange}
            list={tipoPlanejamentoSucessorioList(false)}
        />
    )
}

export const DescricaoOutros = ({ item, ind, handleChange, expandiu }) => {

    return (
        <TextValidatorText
            name={`patrimonioImobilizado[${ind}].descricaoOutros`}
            label={LABEL.descricao}
            value={item.descricaoOutros || ''}
            onChange={handleChange}
            tamMax={TAMMAX.descricaoPatrimonioImobilizadoOutros}
            notToUpperCase={true}
            disabled={expandiu}
        />
    )
}

export const HelpDescricaoOutros = () => {
    
    return (
        <IconButtonHelp
            helpTitle={LABEL.descricao}
            helpText={HELPTEXT.descricaoPatrimonioImobilizadoOutros}
        />
    )
}

export const Observacao = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorTextMultiline
            name={`patrimonioImobilizado[${ind}].observacao`}
            label={LABEL.observacao}
            value={item.observacao || ''}
            onChange={handleChange}
            tamMax={TAMMAX.observacao}
            disabled={item.idPergunta > 0}
        />
    )
}